var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgDish(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1_1_",
    style: {
      enableBackground: "new 0 0 64 64"
    },
    viewBox: "0 0 64 64",
    xmlSpace: "preserve",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M15,30L2.419,13.544C2.147,13.191,2,12.759,2,12.313v-0.295C2,10.904,2.904,10,4.019,10h0    c0.619,0,1.205,0.284,1.587,0.772L19,28L15,30z",
    style: {
      fill: "#CF9E76"
    }
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M22,25L9.419,8.544C9.147,8.191,9,7.759,9,7.313V7.019C9,5.904,9.904,5,11.019,5h0     c0.619,0,1.205,0.284,1.587,0.772L26,23L22,25z",
    style: {
      fill: "#CF9E76"
    }
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M22,25l4-2l-5.696-7.327c-1.073,1.017-2.012,2.177-2.794,3.454L22,25z",
    style: {
      fill: "#B27946"
    }
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M32,13c-6.976,0-12.839,4.761-14.518,11.212l0.006,0.004C18.305,24.077,19.143,24,20,24     c4.618,0,8.749,2.087,11.501,5.37l0,0.014C34.252,26.097,38.378,24,43,24c1.228,0,2.417,0.159,3.559,0.437l0.013-0.009     C44.97,17.868,39.053,13,32,13z",
    style: {
      fill: "#FFEAA7"
    }
  })), /*#__PURE__*/React.createElement("path", {
    d: "M20,24c4.618,0,8.749,2.087,11.501,5.37l0,0.014C34.252,26.097,38.378,24,43,24    c1.228,0,2.417,0.159,3.559,0.437l0.013-0.009c-0.184-0.752-0.431-1.479-0.723-2.182C44.919,22.087,43.968,22,43,22    c-4.376,0-8.434,1.698-11.493,4.505C28.385,23.627,24.303,22,20,22c-0.604,0-1.199,0.042-1.788,0.105    c-0.291,0.679-0.54,1.38-0.729,2.107l0.006,0.004C18.305,24.077,19.143,24,20,24z",
    style: {
      fill: "#FCD770"
    }
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M32,17c-4.701,0-8.713,2.949-10.287,7.097c3.92,0.445,7.382,2.402,9.788,5.273l0,0.017     c2.54-3.035,6.256-5.05,10.453-5.34L42,24l0.257,0.018C40.661,19.911,36.671,17,32,17z",
    style: {
      fill: "#FCD770"
    }
  })), /*#__PURE__*/React.createElement("path", {
    d: "M22.646,22.224c-0.366,0.591-0.683,1.215-0.933,1.873c3.92,0.445,7.382,2.402,9.788,5.273l0,0.017    c2.54-3.035,6.256-5.05,10.453-5.34L42,24l0.257,0.018c-0.263-0.678-0.598-1.319-0.984-1.924c-3.71,0.383-7.114,1.978-9.766,4.412    C29.035,24.226,25.956,22.747,22.646,22.224z",
    style: {
      fill: "#FFC729"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15,30l4-2l-4.052-5.212c-1.429,0.448-2.782,1.079-4.031,1.872L15,30z",
    style: {
      fill: "#B27946"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5.3,36c1.39-6.847,7.443-12,14.7-12c4.618,0,8.749,2.087,11.501,5.37l0.124,6.755L5.3,36z",
    style: {
      fill: "#FCD770"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M31.586,34H5.868c-0.23,0.649-0.428,1.313-0.568,2l0.013,0h26.31L31.586,34z",
    style: {
      fill: "#FFC729"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M31.625,36.125l-0.124-6.755c-0.429-0.511-0.901-0.982-1.393-1.432    c-1.846,2.142-3.177,4.754-3.768,7.664l-0.101,0.497L31.625,36.125z",
    style: {
      fill: "#FFC729"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.414,35.999L29,36l0.238-2.974C27.278,30.001,23.873,28,20,28    C14.965,28,10.72,31.383,9.414,35.999z",
    style: {
      fill: "#FFEAA7"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.209,34c-0.325,0.635-0.597,1.301-0.795,1.999L29,36l0.16-2H10.209z",
    style: {
      fill: "#FCD770"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2,36h60v0c0,14.359-11.641,26-26,26h-8C13.641,62,2,50.359,2,36L2,36z",
    style: {
      fill: "#ECC19C"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M26.259,36L29,36l0.238-2.974c-0.402-0.621-0.879-1.186-1.395-1.712    c-0.68,1.333-1.195,2.768-1.503,4.288L26.259,36z",
    style: {
      fill: "#FCD770"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M28.3,36c1.39-6.847,7.443-12,14.7-12c7.249,0,13.297,5.142,14.695,11.977L28.3,36z",
    style: {
      fill: "#FCD770"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M28.3,36l29.395-0.023c-0.139-0.679-0.336-1.335-0.563-1.977H28.868    C28.638,34.649,28.439,35.313,28.3,36z",
    style: {
      fill: "#FFC729"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M32.414,35.999C33.721,31.382,37.965,28,43,28c5.035,0,9.28,3.383,10.586,7.999L32.414,35.999z",
    style: {
      fill: "#FFEAA7"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2,36c0,1.36,0.105,2.696,0.307,4H55h2h4.693C61.895,38.696,62,37.36,62,36H2z",
    style: {
      fill: "#DFB28B"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M32.414,35.998l21.171,0.001c-0.198-0.699-0.47-1.365-0.795-1.999H33.209    C32.884,34.634,32.612,35.3,32.414,35.998z",
    style: {
      fill: "#FCD770"
    }
  })), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M58.48,35c-1.431-5.548-5.735-9.837-11.1-11.376c-0.591-2.084-1.569-3.975-2.857-5.595C44.79,17.517,45,16.884,45,16.005    c0-1.601-0.676-2.445-1.219-3.124C43.311,12.293,43,11.905,43,11.005c0-0.9,0.311-1.288,0.781-1.876    C44.324,8.45,45,7.604,45,6.003s-0.676-2.447-1.219-3.126C43.311,2.289,43,1.9,43,1h-2c0,1.602,0.676,2.447,1.219,3.126    C42.689,4.714,43,5.103,43,6.003c0,0.9-0.311,1.289-0.781,1.877C41.676,8.559,41,9.404,41,11.005s0.676,2.446,1.219,3.125    C42.689,14.718,43,15.106,43,16.005c0,0.126-0.013,0.232-0.025,0.34c-2.228-2.098-5.046-3.542-8.15-4.093    c0.1-0.357,0.175-0.755,0.175-1.246c0-1.601-0.676-2.446-1.219-3.125C33.311,7.292,33,6.903,33,6.003    c0-0.9,0.311-1.289,0.781-1.877C34.324,3.447,35,2.602,35,1h-2c0,0.9-0.311,1.289-0.781,1.877C31.676,3.556,31,4.401,31,6.003    s0.676,2.447,1.219,3.126C32.689,9.717,33,10.105,33,11.005c0,0.44-0.082,0.754-0.21,1.028C32.527,12.021,32.266,12,32,12    c-2.105,0-4.128,0.422-5.992,1.176c-0.077-0.1-0.154-0.204-0.227-0.295c-0.47-0.588-0.78-0.976-0.78-1.875    c0-0.9,0.311-1.288,0.781-1.876C26.324,8.45,27,7.604,27,6.003s-0.676-2.447-1.219-3.126C25.311,2.289,25,1.9,25,1h-2    c0,1.602,0.676,2.447,1.219,3.126C24.689,4.714,25,5.103,25,6.003s-0.311,1.289-0.781,1.877C23.676,8.559,23,9.404,23,11.005    c0,1.547,0.63,2.386,1.162,3.053c-0.867,0.487-1.682,1.057-2.442,1.694L13.393,5.154C12.816,4.42,11.951,4,11.019,4    C9.354,4,8,5.354,8,7.019v0.295c0,0.662,0.223,1.315,0.626,1.841l9.04,11.753c-0.376,0.761-0.694,1.558-0.949,2.388L6.393,10.154    C5.816,9.42,4.951,9,4.019,9C2.354,9,1,10.354,1,12.019v0.295c0,0.662,0.223,1.315,0.626,1.841l9.101,11.832    c-3,2.139-5.248,5.293-6.208,9.014H1v1c0,14.888,12.112,27,27,27h8c14.888,0,27-12.112,27-27v-1H58.48z M56.42,35h-2.111    c-1.68-4.745-6.221-8-11.309-8c-5.088,0-9.629,3.255-11.309,8H29.58c1.744-5.862,7.203-10,13.42-10    C49.214,25,54.675,29.139,56.42,35z M52.16,35H33.84c1.572-3.588,5.163-6,9.16-6C46.997,29,50.588,31.412,52.16,35z M27.519,35    H10.84c1.572-3.588,5.163-6,9.16-6c3.236,0,6.218,1.556,8.099,4.165C27.867,33.758,27.681,34.373,27.519,35z M23.164,23.329    C24.88,20.101,28.287,18,32,18c3.708,0,7.015,1.995,8.757,5.173c-3.578,0.51-6.818,2.214-9.257,4.734    C29.23,25.554,26.331,23.966,23.164,23.329z M45.131,23.158C44.43,23.064,43.722,23,43,23c-0.031,0-0.062,0.004-0.093,0.004    C40.956,18.728,36.752,16,32,16c-4.705,0-9.005,2.809-10.932,7.059C20.713,23.035,20.359,23,20,23    c-0.367,0-0.729,0.023-1.09,0.048C20.945,17.656,26.128,14,32,14C37.94,14,43.129,17.698,45.131,23.158z M10.212,7.935    C10.075,7.757,10,7.537,10,7.313V7.019C10,6.457,10.457,6,11.019,6c0.315,0,0.607,0.142,0.802,0.389l8.438,10.739    c-0.549,0.592-1.054,1.229-1.51,1.903L10.212,7.935z M3.212,12.935C3.075,12.757,3,12.537,3,12.313v-0.295    C3,11.457,3.457,11,4.019,11c0.315,0,0.607,0.142,0.802,0.389l9.849,12.535c-0.773,0.275-1.517,0.614-2.234,1.001L3.212,12.935z     M20,25c3.884,0,7.546,1.615,10.189,4.43c-0.41,0.546-0.779,1.125-1.118,1.724C26.807,28.532,23.525,27,20,27    c-5.088,0-9.629,3.255-11.309,8H6.58C8.324,29.138,13.783,25,20,25z M36,61h-8C15.927,61,5.832,52.396,3.508,41H55v-2H3.186    c-0.079-0.66-0.14-1.326-0.167-2H60.98c-0.027,0.674-0.087,1.34-0.167,2H57v2h3.492C58.168,52.396,48.073,61,36,61z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M48,21h2c0-0.898,0.311-1.286,0.78-1.873c0.544-0.678,1.22-1.523,1.22-3.123c0-1.601-0.676-2.445-1.219-3.124    C50.311,12.293,50,11.905,50,11.005c0-0.9,0.311-1.288,0.781-1.876C51.324,8.45,52,7.604,52,6.003s-0.676-2.447-1.219-3.126    C50.311,2.289,50,1.9,50,1h-2c0,1.602,0.676,2.447,1.219,3.126C49.689,4.714,50,5.103,50,6.003c0,0.9-0.311,1.289-0.781,1.877    C48.676,8.559,48,9.404,48,11.005s0.676,2.446,1.219,3.125C49.689,14.718,50,15.106,50,16.005c0,0.898-0.311,1.286-0.78,1.873    C48.676,18.556,48,19.4,48,21z"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgDish);
export default __webpack_public_path__ + "static/media/dish.9015dfdc7cbad72f41b0b522fc6e67d9.svg";
export { ForwardRef as ReactComponent };